import React, {memo, useMemo} from 'react';

import {getTranslationData, useGallerySpec} from '../../util/gallery';
import {ReportPageLanguageTags} from './ReportPageLanguageTags';
import {ReportPageRSSLinks} from './ReportPageRSSLinks';

type ReportPageMetaTagsProps = {
  viewId: string;
};

const ReportPageMetaTagsComp = ({viewId}: ReportPageMetaTagsProps) => {
  const {
    gallerySpec: {reportIDsWithTagIDs},
  } = useGallerySpec();

  // TODO - should we be using reportIDsWithTagIDs or reportIDsWithTagV2IDs
  const translationData = useMemo(
    () => getTranslationData(reportIDsWithTagIDs, viewId),
    [reportIDsWithTagIDs, viewId]
  );
  return (
    <>
      <ReportPageRSSLinks />
      {translationData != null && (
        <ReportPageLanguageTags translationData={translationData} />
      )}
    </>
  );
};

export const ReportPageMetaTags = memo(ReportPageMetaTagsComp);
